import AppConfig from '../AppConfig';

// https://stackoverflow.com/questions/3420004/access-parent-url-from-iframe
const parentHref = (window.location != window.parent.location)
  ? document.referrer
  : document.location.origin;
const isPremiumSomething = parentHref.indexOf('premium') !== -1;
class AppApiUrl {

  conf = {
    apiUrlLocal: AppConfig.apiUrlLocal,
    apiUrlStaging: AppConfig.apiUrlStaging,
    apiUrlProd: AppConfig.apiUrlProd
  };


  getUrl() {
    return `${this.getWebDomain()}${this.getAPIEndPoint()}`
  };

  getWebDomain() {
    return isPremiumSomething
      ? AppConfig.PREMIUM_WEB_URL
      : AppConfig.WEB_URL
  }

  getAPIEndPoint() {
    if (isPremiumSomething) {
      return AppConfig.PREMIUM_API_ENDPOINT;
    }

    switch (AppConfig.mode) {
      case "local":
      case "dev":
        return this.conf.apiUrlLocal;
      case "staging":
        return this.conf.apiUrlStaging;
      case "prod":
      default:
        return this.conf.apiUrlProd;
    }
  }

  /**
   * @sample http://cnbdev.cine-books.com/api/v7/viever/get-book?guid=B18AB12A-7AB2-44ce-837B-90DDA66B8CCC&resolution=720&ratio_x=2000&ratio_y=1024
   *
   * @param params
   * @returns {string}
   */
  getBookInfoUrl(params) {
    let screenSize = this.getScreenSize();
    return `${this.getUrl()}get-book?resolution=${params.resolution}&ratio_x=${screenSize.width}&ratio_y=${screenSize.height}&guid=${params.guid}&domain=${parentHref}`;
  };

  getTokenUrl(apiKey, userKey) {
    return `${this.getUrl()}get-token?access_key=${apiKey}&user_key=${userKey}&domain=${parentHref}`;
  };

  getWidgetInfoUrl(channelId) {
    return this.getUrl() + 'get-channel?id=' + channelId + '&token=8be847e430d746c48c8cfc847506a682';
  }

  getIsBookBoughtUrl(token, guid) {
    return this.getUrl() + 'is-book-bought?guid=' + guid + '&token=' + token;
  }

  getScreenSize() {
    // was w: 2000, h: 1024
    return {
      width: window.screen.availWidth,
      height: window.screen.availHeight
    }
  };

  getTrakingUrl = () => this.getUrl() + 'set-view';
}

export default new AppApiUrl();


// WEBPACK FOOTER //
// ./src/api/AppApiUrl.js